import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import {
  ActionPerformed,
  PushNotificationSchema,
  PushNotifications,
  Token,
} from '@capacitor/push-notifications';
import { Storage } from '@ionic/storage-angular';
import { NotificacionService } from '../notificaciones-service/notificacion.service';
import { ApiService } from 'src/app/api.service';
import { LocalNotifications } from '@capacitor/local-notifications';

@Injectable({
  providedIn: 'root'
})
export class PushNotificationsService {

  constructor(public platform: Platform,
    private Storage: Storage,
    private ns: NotificacionService,
    private api: ApiService,
  ) {
    if (this.platform.is('capacitor')){
      this.initializeNotificationEvents();
    }
  }

  private initializeNotificationEvents() {
     // On success, we should be able to receive notifications
     PushNotifications.addListener('registration',
      (token: Token) => {
        let data = {
          status: 'true',
          token: token.value,
        };
        this.Storage.set('token_fcm', data);

        this.api.guardar_token_fcm(token.value)
        .then(() => {console.log("token fcm enviado!")} )
        .catch(error => {console.log("error en envío de token fcm:", error)} );

      }
    );

    // Some issue with our setup and push will not work
    PushNotifications.addListener('registrationError',
      (error: any) => {
        console.log("error al registrar token fcm",  JSON.stringify(error));
      }
    );

    // Show us the notification payload if the app is open on our device
    PushNotifications.addListener('pushNotificationReceived',
      async (notification: PushNotificationSchema) => {
        // alert('Push received when APP IS OPEN: ' + JSON.stringify(notification));
        console.log('Push received when APP IS OPEN', notification);
        // Mostrar la notificación localmente para que el usuario la vea
        try {
          await this.showLocalNotification(notification);
        } catch (error) {
          console.log(error);
        };

        this.ns.changeListNotification(true, null);
      }
    );

    // Method called when tapping on a notification
    PushNotifications.addListener('pushNotificationActionPerformed',
      (notification: ActionPerformed) => {
        // alert('Push action performed: ' + JSON.stringify(notification));
        console.log('Push action performed: ' + JSON.stringify(notification));
      }
    );

  }

  public requestPermissions() {
    console.log("request notificacion permissions! ");
    PushNotifications.requestPermissions().then(result => {
      if (result.receive === 'granted') {
        // Register with Apple / Google to receive push via APNS/FCM
        PushNotifications.register();
      }
    });
  }

  async showLocalNotification(notification: PushNotificationSchema) {
    try {
      // Pedir permisos para notificaciones locales
      const permResult = await LocalNotifications.requestPermissions();

      if (permResult.display === 'granted') {
        await LocalNotifications.schedule({
          notifications: [{
            title: notification.title,
            body: notification.body,
            id: Date.now(),
            sound: 'default'
          }]
        });
      };

    } catch (error) {
      throw error
    }
  }
}
